/**
 * Class controlling the visibility of the embedded autokuva 360 iframes dialog.
 * It listens to specific button clicks to show and hide the modal dialog.
 * Additionally, it provides backward compatibility for older browsers that do not
 * support the dialog.openModal method (such as Safari at the time of writing).
 */
class Vehicle360ImageModal {
  /**
   * Control buttons for toggling the dialog.
   * @type {HTMLElement[]}
   * @private
   */
  #controlBtns = [];
  #controlBtnsMobile = [];

  /**
   * The modal element for desktop.
   * @type {HTMLElement}
   * @private
   */
  #modal;

  /**
   * The modal element for mobile.
   * @type {HTMLElement}
   * @private
   */
  #modalMobile;

  constructor() {
    this.toggleDialog = this.toggleDialog.bind(this);
    this.#controlBtns.push(document.querySelector('#image_360'));
    this.#controlBtns.push(document.querySelector('#autokuva360__close'));
    this.#controlBtns.push(document.querySelector('#autokuva360'));

    this.#controlBtnsMobile.push(document.querySelector('#image_360_mobile'));
    this.#controlBtnsMobile.push(document.querySelector('#autokuva360-mobile__close'));
    this.#controlBtnsMobile.push(document.querySelector('#autokuva360-mobile'));

    this.#modal = document.querySelector('#autokuva360');
    if (this.#modal) {
      this.#controlBtns.forEach((element) =>
        element?.addEventListener('click', this.toggleDialog)
      );
    }

    this.#modalMobile = document.querySelector('#autokuva360-mobile');
    if (this.#modalMobile) {
      this.#controlBtnsMobile.forEach((element) =>
        element?.addEventListener('click', this.toggleDialog)
      );
    }
  }

  /**
   * Toggle the visibility of the dialog.
   */
  toggleDialog(event) {
    event?.stopPropagation?.();

    const target = event.target;
    const isMobile = this.#controlBtnsMobile.includes(target);
    const modal = isMobile ? this.#modalMobile : this.#modal;

    const isModalOpen = modal.hasAttribute('open');
    if (modal?.showModal) {
      if (isModalOpen) {
        modal.close();
      } else {
        modal.showModal();
      }
    } else {
      modal.toggleAttribute('open', !isModalOpen);
      document
        .querySelector('html')
        .classList.toggle('open-dialog', !isModalOpen);
      // This is needed to add some custom workarounds because Safari is being a dummy
      modal.classList.add('vehicle-page__360-image--legacy');
    }
  }
}

export { Vehicle360ImageModal };
